import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { putField } from "../../../../../utils/form";
import store from "../../../../../store";
import { callRequestStatus } from "../../../storage-location/request/request.section";
import { callDepartment } from "../request/request.section";

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.samplingAnalysis.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1"
                    ? record.refUserCompany?.companyNameTh
                    : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingAnalysis.products"),
            dataIndex: "products",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.products?.map(d => {
                    return <div>{ d.refSendSamplingProduct?.refSampling?.approveCode }</div>
                }) || [];
                return <>{...labels}</>
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.samplingAnalysis.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
